import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { en } from './en';
import { ru } from './ru';
import { uk } from './uk';
import { es } from './es';
import { ar } from './ar';
import { zh } from './zh';

const resources = {
  en: {
    translation: en
  },
  ru: {
    translation: ru
  },
  uk: {
    translation: uk
  },
  es: {
    translation: es
  },
  ar: {
    translation: ar
  },
  zh: {
    translation: zh
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['querystring', 'navigator'],
      lookupQuerystring: 'lang'
    }
  });

export default i18n; 